import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface IClientType {
  id: number
  name: string
}

interface ClientTypeAutocompleteProps {
  clientTypeId: number | null
  handleInputChange: (inputName: string, value: any) => void
}

export function ClientTypeAutocomplete({ clientTypeId, handleInputChange }: ClientTypeAutocompleteProps) {
  const { t } = useTranslation(['global'])

  const clientTypes: IClientType[] = [
    { id: 0, name: t('admin.people.esthetic-professional') },
    { id: 1, name: t('admin.people.final-audience') },
    { id: 2, name: t('admin.people.esthetic-academy-student') },
    { id: 3, name: t('admin.people.esthetic-academy-professor') }
  ]

  const handleAutoCompleteChange = (value: IClientType | null) => {
    if (value !== null) handleInputChange('client_type', value.id)
  }

  return (
    <Autocomplete
      id="autocomplete-client-types"
      value={clientTypes.find((clientType: IClientType) => clientType.id === clientTypeId)}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={clientTypes}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField {...params} label="Tipo de cliente" variant="filled" fullWidth InputLabelProps={{ shrink: true }} />
      )}
    />
  )
}
